/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Features_TitleInputs */

const en_meta_features_title = /** @type {(inputs: Meta_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features - Listening: Text to Speech for Academic Papers`)
};

const es_meta_features_title = /** @type {(inputs: Meta_Features_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones - Listening: Texto a voz para artículos académicos`)
};

/**
* | output |
* | --- |
* | "Features - Listening: Text to Speech for Academic Papers" |
*
* @param {Meta_Features_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_features_title = /** @type {((inputs?: Meta_Features_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Features_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_features_title(inputs)
	return en_meta_features_title(inputs)
});